import type { BodyRouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { Log } from 'models/service';

export const createTaskLog = async ({ body, routeParams: { id } }: BodyRouteParamsRequest<Log[], { id: string }>) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  apiClient.post<any, ApiClientResponse<any>>(routes.activities.submissions(id), body);
